import React from 'react';
import {Dropdown} from "antd";
import {injectIntl} from "react-intl";
import SAInputNumber from "../../common/input/SAInputNumber";
import moment from 'moment';
import SATimePicker from "../../common/input/SATimePicker";
import Constants from "../../../services/Constants";

import "./AddSlotMenu.css"

class AddSlotMenu extends React.Component {

  maxTotalArrivals = 'maxTotalArrivals';
  maxWaitingArrivals = 'maxWaitingArrivals';
  maxNonWaitingArrivals = 'maxNonWaitingArrivals';
  maxHomeServiceArrivals = 'maxHomeServiceArrivals';

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => {
    return {
      slot: {
        startTime: this.props.data && this.props.data.startTime,
        endTime: this.props.data && this.props.data.endTime,
        maxTotalArrivals: this.props.data && this.props.data.maxTotalArrivals,
        maxWaitingArrivals: this.props.data && this.props.data.maxWaitingArrivals,
        maxNonWaitingArrivals: this.props.data && this.props.data.maxNonWaitingArrivals,
        maxHomeServiceArrivals: this.props.data && this.props.data.maxHomeServiceArrivals,
      },
      visible: false,
    };
  };

  resetState = () => {
    this.setState(this.getInitialState());
  };

  onSave = () => {
    const errors = this.verifyInput(this.state.slot);
    this.setState({errors});

    if (Object.keys(errors).length === 0) {
      this.setState({visible: false});
      this.props.onValidate(this.state.slot);
      setTimeout(() => this.resetState(), 500);
    }
  };

  verifyInput = (input) => {
    const errors = [];

    Object.keys(input).forEach(key => {
      if (input[key] === undefined || input[key] === null) {
        errors[key] = {message: 'error.not.null'};
      }
    });
    if (input.maxTotalArrivals < input.maxWaitingArrivals) {
      errors[this.maxWaitingArrivals] = {message: 'error.less.or.equal', args: [input.maxTotalArrivals]};
    }
    if (input.maxTotalArrivals < input.maxHomeServiceArrivals) {
      errors[this.maxHomeServiceArrivals] = {message: 'error.less.or.equal', args: [input.maxTotalArrivals]};
    }
    if (input.startTime && input.endTime && moment(input.startTime, "HH:mm").isSameOrAfter(moment(input.endTime, "HH:mm"))) {
      errors['endTime'] = {message: 'error.greater.or.equal', args: [input.startTime]};
    }
    if (input.maxTotalArrivals === 0) {
      errors[this.maxTotalArrivals] = {message: 'error.greater.or.equal', args: [1]};
    }
    return errors;
  };

  onTimePickerChange = (time, name) => {
    const {slot} = this.state;
    slot[name] = time ? moment(time).format(Constants.TIME_FORMAT_API) : undefined;
    this.setState({slot});
  };

  onInputNumberChange = (number, name) => {
    const {slot} = this.state;
    if (name === this.maxWaitingArrivals) {
      slot[this.maxTotalArrivals] = number + (Number(slot[this.maxNonWaitingArrivals]) || 0);
    } else if (name === this.maxNonWaitingArrivals) {
      slot[this.maxTotalArrivals] = number + (Number(slot[this.maxWaitingArrivals]) || 0);
    }
    slot[name] = number;
    this.setState({slot});
  };

  handleVisibleChange = () => {
    this.setState({visible: true});
  };

  render() {
    const {intl: {formatMessage}} = this.props;
    const {errors, slot: {startTime, endTime, maxTotalArrivals, maxHomeServiceArrivals, maxWaitingArrivals, maxNonWaitingArrivals}} = this.state;
    const dropdownPositionClassName = "dropdown--bottom-" + (this.props.dropdownPosition || "left");

    const overlay = (
      <div className={"dropdown dropdown--lg slot-menu--overlay " + dropdownPositionClassName}>
        <ul className="list">
          <li>
            <label>{formatMessage({id: 'label.startTime'})}</label>
            <SATimePicker
              className={"right"} placeholder={formatMessage({id: "placeholder.startTime"})}
              value={startTime} onChange={time => this.onTimePickerChange(time, 'startTime')}
              defaultOpenValue={'07:00'}
              error={errors && errors['startTime']}/>
          </li>
          <li>
            <label>{formatMessage({id: 'label.endTime'})}</label>
            <SATimePicker
              className={"right"} placeholder={formatMessage({id: "placeholder.endTime"})}
              value={endTime} onChange={time => this.onTimePickerChange(time, 'endTime')}
              defaultOpenValue={'07:00'}
              error={errors && errors['endTime']}/>
          </li>
          <li>
            <label>{formatMessage({id: 'label.maxTotalArrivals'})}</label>
            <SAInputNumber
              disabled
              className={"right"}
              placeholder={formatMessage({id: "placeholder.maxTotalArrivals"})}
              value={maxTotalArrivals} onChange={number => this.onInputNumberChange(number, this.maxTotalArrivals)}
              min={0} error={errors && errors[this.maxTotalArrivals]}/>
          </li>
          <li>
            <label>{formatMessage({id: 'label.maxWaitingArrivals'})}</label>
            <SAInputNumber
              className={"right"} placeholder={formatMessage({id: "placeholder.maxWaitingArrivals"})}
              value={maxWaitingArrivals} onChange={number => this.onInputNumberChange(number, this.maxWaitingArrivals)}
              min={0} error={errors && errors[this.maxWaitingArrivals]}/>
          </li>
          <li>
            <label>{formatMessage({id: 'label.maxNonWaitingArrivals'})}</label>
            <SAInputNumber
              className={"right"}
              placeholder={formatMessage({id: "placeholder.maxNonWaitingArrivals"})}
              value={maxNonWaitingArrivals}
              onChange={number => this.onInputNumberChange(number, this.maxNonWaitingArrivals)}
              min={0} error={errors && errors[this.maxNonWaitingArrivals]}/>
          </li>
          <li>
            <label>{formatMessage({id: 'label.maxHomeServiceArrivals'})}</label>
            <SAInputNumber
              className={"right"}
              placeholder={formatMessage({id: "placeholder.maxHomeServiceArrivals"})}
              value={maxHomeServiceArrivals}
              onChange={number => this.onInputNumberChange(number, this.maxHomeServiceArrivals)}
              min={0} error={errors && errors[this.maxHomeServiceArrivals]}/>
          </li>
        </ul>
        <br/>

        <div className="ant-table-filter-dropdown-btns">
          <a onClick={this.onSave}
             className="ant-table-filter-dropdown-link confirm">{formatMessage({id: 'action.add'})}</a>
          <a onClick={this.resetState}
             className="ant-table-filter-dropdown-link clear">{formatMessage({id: 'action.cancel'})}</a>
        </div>
      </div>
    );

    return (
      <div className={"dropdown-wrapper"}>
        <Dropdown overlay={overlay} trigger={['click']}
                  onVisibleChange={this.handleVisibleChange}
                  visible={this.state.visible}
        >
          {this.props.children}
        </Dropdown>
      </div>
    )
  }
}

export default injectIntl(AddSlotMenu);
